<template>
  <v-container container--fluid fill-height class="pa-0"> </v-container>
</template>

<script>
export default {
  components: {},
  $_veeValidate: {
    validator: "new",
  },
  data: () => ({
    drawer: true,
    loading: false,
  }),
};
</script>
<style scoped lang="css">
.bg {
  /* The image used */
  background-image: url("https://cdn.siap.id/s3/siap_belajar/sim/bg-login-siap-belajar.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
